import { render, staticRenderFns } from "./RemoveRelationGroup.vue?vue&type=template&id=35fae461"
import script from "./RemoveRelationGroup.vue?vue&type=script&lang=js"
export * from "./RemoveRelationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports